import "./ProgressBar.css";

export default function ProgressBar({ progress = 0, text }) {
  return (
    <div className="progress-wrapper">
      <div className="progress-bar">
        <div 
          className="progress-bar-fill" 
          style={{ width: `${progress}%`, transition: "width 0.3s ease-in-out" }} 
        />
      </div>
      {text && <p>{text}</p>}
        <video width="100" autoPlay muted loop playsInline style={{ marginTop: '-20px' }}>
          <source src="https://slwelding.blob.core.windows.net/slwcontainer/db.mp4" type="video/mp4" />
        </video>
    </div>
  );
}
